export default {
    inserted: function(el) {
        el.classList.add("printable");
    },
}
